var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackHomeTgnpdclLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4V5.2C0 4.94667 0.0621248 4.70667 0.186375 4.48C0.310625 4.25333 0.481833 4.06667 0.7 3.92L5.95 0.32C6.25625 0.106667 6.60625 0 7 0C7.39375 0 7.74375 0.106667 8.05 0.32L13.3 3.92C13.5187 4.06667 13.6902 4.25333 13.8145 4.48C13.9387 4.70667 14.0006 4.94667 14 5.2V12.4C14 12.84 13.8285 13.2168 13.4855 13.5304C13.1425 13.844 12.7307 14.0005 12.25 14H9.625C9.37708 14 9.16941 13.9232 9.002 13.7696C8.83458 13.616 8.75058 13.4261 8.75 13.2V9.2C8.75 8.97333 8.666 8.78346 8.498 8.6304C8.33 8.47733 8.12233 8.40053 7.875 8.4H6.125C5.87708 8.4 5.66942 8.4768 5.502 8.6304C5.33458 8.784 5.25058 8.97386 5.25 9.2V13.2C5.25 13.4267 5.166 13.6168 4.998 13.7704C4.83 13.924 4.62233 14.0005 4.375 14H1.75C1.26875 14 0.856916 13.8435 0.5145 13.5304C0.172083 13.2173 0.000583333 12.8405 0 12.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackHomeTgnpdclLogo);
export default __webpack_public_path__ + "static/media/back-home-tgnpdcl-logo.ee2fb60942918fa4c1d5315a26fc43a1.svg";
export { ForwardRef as ReactComponent };